<template>
  <div class="info-block spacex-12">
    <InfoIcon class="icon-20px orange-icon" />
    <span class="info-block__text">{{ text }}</span>
  </div>
</template>

<script>
  import InfoIcon from '@/assets/icons/info.svg';

  export default {
    name: 'InfoBlock',
    components: {
      InfoIcon,
    },
    props: {
      text: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .info-block {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 12px;

    border: 1px solid $grey200;
    box-sizing: border-box;
    border-radius: 4px;

    &__text {
      color: $grey900;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }
  }
</style>
